/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */
var desktop_min_width = 1320; // also defined in critical.js
aucor_navigation(document.getElementById('primary-navigation'), {
  wrapper:           '.site-header', // min width in pixels
  desktop_min_width: desktop_min_width, // min width in pixels
  menu_toggle:       '#menu-toggle' // selector for toggle
});

aucor_navigation(document.getElementById('cta-navigation'), {
  desktop_min_width: desktop_min_width, // min width in pixels
  menu_toggle: null // selector for toggle
});

// dropdowns
aucor_dropdown(document.getElementById('languages-desktop'), {
  desktop_min_width: desktop_min_width
});
aucor_dropdown(document.getElementById('languages-mobile'), {
  desktop_min_width: desktop_min_width
});

/**
 * Responsive videos
 */
fitvids();


/**
 * Set header mega menu parents and non mega menu parents
 * (mega menu parent <li> should be posisiton static and non mega menu parent position absolute)
 */
function sb_setup_menu_parents() {

  var has_megamenu = false;
  var menu_items = document.querySelectorAll('#primary-navigation__items > li');

  for (var i = 0; i < menu_items.length; i++) {
    if (menu_items[i].querySelector('.megamenu--size-1')) {
      menu_items[i].classList.add('menu-item--has-tinymenu');
    } else {
      menu_items[i].classList.add('menu-item--has-megamenu');
    }
  }

}
sb_setup_menu_parents();

/**
 * Tweak mobile menu margin
 */
var sb_mobile_menu_margins = function() {
  var menu_top = document.getElementById('masthead');
  var menu_bottom = document.getElementById('primary-navigation');
  if (menu_top && menu_bottom && Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < desktop_min_width) {
    menu_bottom.style.marginTop = menu_top.offsetHeight + 'px';
  } else {
    menu_bottom.style.marginTop = 0;
  }
}
sb_mobile_menu_margins();
window.addEventListener('resize', function(event){
  sb_mobile_menu_margins();
});

/**
 * Tweak header margin
 */
var sb_header_menu_margins = function() {
  var menu = document.getElementById('masthead');
  var page = document.getElementById('page');
  if (menu && page) {
    page.style.marginTop = menu.offsetHeight + 'px';
  } else {
    page.style.marginTop = 0;
  }
}
sb_header_menu_margins();
window.addEventListener('resize', function(event){
  sb_header_menu_margins();
});

/**
 * Open current menu tree in mobile menu
 */
function sb_set_active_menu_tree() {
  var menu = document.getElementById('primary-navigation__items');
  var menu_item;
  if (menu && Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < desktop_min_width) {
    var active_menu_items = menu.querySelectorAll('.current_page_ancestor, .current-menu-item');
    if (active_menu_items.length) {
      for (var i = active_menu_items.length - 1; i >= 0; i--) {
        menu_item = active_menu_items[i].querySelector('.js-menu-caret');
        if (menu_item) {
          menu_item.click();
          return;
        }
      }
    }
  }
}
sb_set_active_menu_tree();

/**
 * Copy and paste mobile menu fixed items (have class "menu-item-hide-mobile")
 */
function sb_set_mobile_sticky_items() {

  var menu = document.getElementById('masthead');
  if (!menu) {
    return;
  }

  var wrapper = document.getElementById('primary-navigation__sticky');
  if (!wrapper) {
    return;
  }

  var target = document.getElementById('primary-navigation__sticky__items');
  if (!target) {
    return;
  }

  var to_copy = menu.querySelectorAll('.menu-item-hide-mobile');
  var clone;
  if (to_copy.length > 0) {
    wrapper.classList.add('primary-navigation__sticky--active');
    for (var i = 0; i < to_copy.length; i++) {
      clone = to_copy[i].cloneNode(true);
      target.appendChild(clone);
    }
  }

}
sb_set_mobile_sticky_items();

/**
 * Mark two last items in primary menu for alternative menu flow (not enough room for tinymenu)
 */
function sb_alternative_menu_flow() {
  var menu = document.getElementById('masthead');
  if (menu) {
    var items = menu.querySelectorAll('#primary-navigation__items > li');
    if (items.length > 2) {
      var last_index = items.length - 1;
      var second_last_index = last_index - 1;
      items[last_index].classList.add('menu-item--alt-flow');
      items[second_last_index].classList.add('menu-item--alt-flow');
    }
  }
}
sb_alternative_menu_flow();

/**
 * Sticky navigation on scroll, maybe
 */
var scroll_position = 0;
window.addEventListener('scroll', function() {


  //if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < desktop_min_width) {
  //  return;
  //}

  var menu = document.getElementById('masthead');
  if (menu) {

    // no changes if mobile menu is open
    if (menu.classList.contains('active') && Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < desktop_min_width) {
      menu.classList.remove('site-header--hidden');
      menu.classList.remove('site-header--sticky');
      return;
    }

    var difference = Math.abs(pageYOffset - scroll_position);
    if (pageYOffset >= 150) {
      if (difference > 8) {
        // show sticky only when scroll upwards and at least 500px from top
        if (pageYOffset >= 150 && pageYOffset <= scroll_position) {
          menu.classList.add('site-header--sticky');
          menu.classList.remove('site-header--hidden');
        } else {
          if (menu.classList.contains('site-header--sticky')) {
            menu.classList.add('site-header--hidden');
            menu.classList.remove('site-header--sticky');
          }
        }
      }
    }
  }

  // quick exit if were are on top
  if (pageYOffset < 150) {
    if (pageYOffset == 0) {
      menu.classList.remove('site-header--hidden');
      menu.classList.remove('site-header--sticky');
    } else if (pageYOffset <= scroll_position) {
      menu.classList.add('site-header--sticky');
    } else {
      menu.classList.remove('site-header--hidden');
      menu.classList.remove('site-header--sticky');
    }
  }


  scroll_position = pageYOffset;
});

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function(e){

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function() {
      objectFitPolyfill();
    });

  });
}

/**
 * List item tabs
 *
 * Checks for tables in content
 */
window.addEventListener("load", function() {
  // store tabs variable
  var myTabs = document.querySelectorAll("ul.tab-links > li");
  function myTabClicks(tabClickEvent) {
    for (var i = 0; i < myTabs.length; i++) {
      myTabs[i].classList.remove("active");
    }
    var clickedTab = tabClickEvent.currentTarget;
    clickedTab.classList.add("active");
    tabClickEvent.preventDefault();
    var myContentPanes = document.querySelectorAll(".tab");
    for (i = 0; i < myContentPanes.length; i++) {
      myContentPanes[i].classList.remove("active");
    }
    var anchorReference = tabClickEvent.target;
    var activePaneId = anchorReference.getAttribute("href");
    var activePane = document.querySelector(activePaneId);
    activePane.classList.add("active");
  }
  if (myTabs.length) {
    for (i = 0; i < myTabs.length; i++) {
      myTabs[i].addEventListener("click", myTabClicks)
    }
  }

  var tablinks = document.getElementsByClassName('tablink');
  if (tablinks.length) {
    tablinks[0].click();
  }

  // check for tables in content and add class to parent div if exists (to enable horizontal scroll)
  var tables = document.getElementsByTagName('table');
  for (var j = 0; j < tables.length; j++) {
    var parent = tables[j].parentElement;
    if (parent.tagName == 'DIV' && parent.classList.contains('wysiwyg')) {
      parent.classList.add('content-has-table');
    }
  }

});

/**
 * Custom select dropdown
 * @link https://www.w3schools.com/howto/howto_custom_select.asp
 */
var x, i, j, selElmnt, a, b, c;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("ginput_container_select");
for (i = 0; i < x.length; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 0; j < selElmnt.length; j++) {
    /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        var y, i, k, s, h;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        h = this.parentNode.previousSibling;
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
  });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x, y, i, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);

/*
 * List item accordion
 */
var sb_accordion = function() {
  var toggle_btns = document.querySelectorAll('.toggle-accordion');

  var sb_accordion_toggle = function(){
    this.classList.toggle('active');
  };

  for (var i = 0; i < toggle_btns.length; i++) {
    toggle_btns[i].addEventListener('click', sb_accordion_toggle, false);
  }
};

sb_accordion();

/**
 * Sets label text to bold when corresponding input field is in focus,
 * removes bold when blurred
 */

var inputFieldList = document.querySelectorAll('.gform_wrapper .ginput_container input, .gform_wrapper .ginput_container textarea');

function onFocusBold() {
    var parent = this.parentNode;
    while(parent.tagName !== 'LI') {
      parent = parent.parentNode;
    }
    parent.firstChild.classList.add('bold-on-focus'); // The label of the input field (not the sublabels in complex fields)
  }
function onBlurNormal() {
    var parent = this.parentElement;
    while(parent.tagName !== 'LI') {
      parent = parent.parentElement;
    }
    parent.firstChild.classList.remove('bold-on-focus');
}

for (var i = 0; i < inputFieldList.length; i++) {
  inputFieldList[i].onfocus = onFocusBold;
  inputFieldList[i].onblur = onBlurNormal;
}

/*
 * Lightbox
 */
var lightbox = GLightbox();
var lightboxDescription = GLightbox({
  selector: 'lightboxDescription'
});

/**
 * Hero slideshow
 */
if (document.querySelector('.hero-slideshow__inner')) {
  var heroSlideshow = new Siema({
    selector: ".hero-slideshow__inner",
    loop: true,
    draggable: false,
    duration: 400,
  });

  document.querySelector('.hero-slideshow__prev').addEventListener('click', function(e) {
    heroSlideshow.prev();
  });
  document.querySelector('.hero-slideshow__next').addEventListener('click', function(e){
    heroSlideshow.next();
  });

  setInterval(function(){heroSlideshow.next()}, 10000);
}

